var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216-216h44.46l393.46-393.46-44.46-44.46L216-260.46V-216Zm-52 52v-118.38l497.62-498.39q8.07-8.24 17.37-11.73 9.3-3.5 19.49-3.5 10.2 0 19.47 3.27 9.28 3.27 17.97 11.58l44.85 44.46q8.31 8.69 11.77 18 3.46 9.31 3.46 19.17 0 10.51-3.64 20.06-3.65 9.55-11.59 17.46L282.38-164H164Zm580.38-535.15-45.23-45.23 45.23 45.23ZM631.3-631.3l-21.84-22.62 44.46 44.46-22.62-21.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDark);
export default __webpack_public_path__ + "static/media/edit_dark.99214f8dd035a30d1b4acbe6dfe9046b.svg";
export { ForwardRef as ReactComponent };